import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Meta} from '../../../../_models/meta';
import {GLMLanguageService} from '../../../../_services/glm-language.service';
import {MapaCurricularFiltrosService} from '../_services/mapa-curricular-filtros.service';
import {EstudioConexionesService} from '../_services/estudio-conexiones.service';
import {MapaCurricularService} from '../_services/mapa-curricular.service';
import {EstudioService} from '../../estudio.service';
// import {combineLatest, Subscription} from 'rxjs';
// import {map} from 'rxjs/operators';
import {ThrobberService} from '../../../../_services/throbber.service';
import {Unidad} from '../../../../_models/unidad';
import { Subscription } from 'rxjs';
// import { Variable } from '@angular/compiler/src/render3/r3_ast';


@Component({
  selector: 'meta-mapa',
  standalone: false,
  templateUrl: './mapa-curricular-meta.component.html',
  styleUrls: ['./mapa-curricular-meta.component.scss']
})
export class MapaCurricularMetaComponent implements OnInit, OnDestroy {

  @Input() meta: Meta;

  @Output()
  onEdit = new EventEmitter();

  private displayLang = {html: '', text: '', indicador: ''};
  public visibility: any;

  private isEmisorConexion = false;
  private isConectable = false;
  private maskOn = false;
  private isBulkActive = false;
  public visibilidad = true;

  conexionesSub = new Subscription();

  enableConnectionsSub = new Subscription();
  emisorClearSub = new Subscription();

  filtrosSub = new Subscription();

  constructor(private cdRef: ChangeDetectorRef,
              private mapaCurricularService: MapaCurricularService,
              private languageService: GLMLanguageService,
              private filtrosService: MapaCurricularFiltrosService,
              private conexionesService: EstudioConexionesService,
              private throbberService: ThrobberService,
              private estudioService: EstudioService) {
  }

  ngOnInit() {
    const initLang = this.languageService.getCurrLanguage();
    // <editor-fold desc="Configuración inicial del lenguaje de visualización de la meta.">

    // this.setLang(initLang.activeLang);

    // </editor-fold>
    this.filtrosSub = this.filtrosService.getFiltrosObservable().subscribe(filtro => {
      if (filtro.hasOwnProperty('detalles')) {
        this.setDetailVisibility(filtro['detalles']);
      } else {
        this.visibility = {
            ambitos: false,
            areas: false,
            cursos: false,
            fullHtml: false,
            tags: false
          };
      }
      if (filtro.hasOwnProperty('filtros')) {
        this.meta.show = this.checkFiltros(filtro.filtros);
      }
    }
    , err => {
    }
    , () => {
    });
    this.meta.show = this.checkFiltros(this.filtrosService.filtros);

    this.emisorClearSub = this.conexionesService.emisorClearAction$.subscribe(() => {
      this.isEmisorConexion = false;
      this.meta.conexiones.status.down = false;
      this.meta.conexiones.status.same = false;
      this.meta.conexiones.status.up = false;
      this.meta.conexiones.active = false;
      this.meta.conexiones.selfColor = '';
      this.meta.conexiones.activeColor = '';
    });

    this.enableConnectionsSub = this.conexionesService.enableConnectionsAction$.subscribe(
      (data: { type: string, objeto: Meta | Unidad, status: boolean }) => {

        if (data.objeto instanceof Unidad && this.meta.categoria.ordenAgrupador === 4) {
          this.isConectable = data.status;
          if (data.objeto.metas.indexOf(this.meta.id) > -1) {
            this.meta.isConnected = data.status;
          }
        } else if (data.objeto instanceof Meta && data.objeto.id !== this.meta.id
          && data.objeto.hasOwnProperty('categoria') && data.objeto.categoria.ordenAgrupador === this.meta.categoria.ordenAgrupador
          || (data.objeto['categoria'].ordenAgrupador - 1) === this.meta.categoria.ordenAgrupador) {
          this.isConectable = data.status;
          if (data.objeto.metas.indexOf(this.meta.id) > -1) {
            this.meta.isConnected = data.status;
          }
        } else {
          if (!this.isEmisorConexion) {
            this.setConectionStatus('maskOn', data.status);
          }
        }
      });

    this.conexionesService.getConexionesObservable().subscribe(evtConexion => {
      if (evtConexion.tipo === 'estadoConexion' && (this.meta.id === +evtConexion.objeto.idOrigen
        || this.meta.id === +evtConexion.objeto.idDestino)) {
        let id;

        if (this.meta.id === +evtConexion.objeto.idOrigen) {
          id = evtConexion.objeto.idDestino;
        } else if (this.meta.id === +evtConexion.objeto.idDestino) {
          this.meta.isConnected = evtConexion.objeto.estado;
          id = evtConexion.objeto.idOrigen;
        }
        if (evtConexion.objeto.estado) {
          this.meta.metas.push(id);
        } else {
          const indice = this.meta.metas.indexOf(id);
          if (indice > -1) {
            this.meta.metas.splice(indice, 1);
          }
        }
      } else if (evtConexion.tipo == 'resultadoConexion' && this.meta.id == evtConexion.objeto.id) {
        this.meta.isConnected = evtConexion.objeto.estado;
      } else if (evtConexion.tipo == 'limpiarConexiones') {
        /*this.conexiones.status.up = false;
        this.conexiones.status.down = false;
        this.conexiones.status.same = false;
        this.conexiones.active = false;
        this.conexiones.activeColor = '';
        this.conexionesActivas = [];*/
      } else if (evtConexion.tipo == 'visibilidadSoloConectadas') {
        if (evtConexion.estado) {
          /*if (this.conexiones.active || this.conexionesActivas.length > 0) {
            this.visibilidad = true;
          } else {
            this.visibilidad = false;
          }*/
        } else {
          this.visibilidad = true;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.enableConnectionsSub) {
      this.enableConnectionsSub.unsubscribe();
    }
    if (this.emisorClearSub) {
      this.emisorClearSub.unsubscribe();
    }
    if (this.filtrosSub) {
        this.filtrosSub.unsubscribe();
    }
  }

  conectarCon() {
    this.isEmisorConexion = !this.isEmisorConexion;
    this.conexionesService.habilitarConexiones(this.meta, this.isEmisorConexion);
  }

  finalizarConexion() {
    this.isEmisorConexion = !this.isEmisorConexion;
    this.conexionesService.habilitarConexiones(this.meta, this.isEmisorConexion);
  }

  setConectionStatus(tipo, estado) {
    this[tipo] = estado;
  }

  setDetailVisibility(detalles) {
    this.visibility = {
        ambitos: false,
        areas: false,
        cursos: false,
        fullHtml: false,
        tags: false
    };
    for (const prop in this.visibility) {
      if (this.visibility.hasOwnProperty(prop)) {
        if (detalles.indexOf(prop) > -1) {
          this.visibility[prop] = true;
        } else {
          this.visibility[prop] = false;
        }
      }
    }
  }

  checkFiltros(filtros) {
    let isVisible = false,
      filtraDescripcion = this.checkDescripcion(filtros['descripcion']),
      filtraAreas = this.checkColeccionFiltro(filtros['areas'], 'materias'),
      filtraCursos = this.checkColeccionFiltro(filtros['cursos'], 'cursos'),
      filtraAmbitos = this.checkColeccionFiltro(filtros['ambitos'], 'ambitos'),
      filtraTags = this.checkColeccionFiltro(filtros['tags'], 'tags');

    isVisible = filtraDescripcion && (filtraAreas && filtraCursos && filtraAmbitos && filtraTags);

    return isVisible;
  }

  checkDescripcion(descripcion) {
    let isVisible = this.meta.show,
      descripcionCheck = descripcion.toLowerCase();

    if (descripcionCheck.length > 0 &&
      ((this.meta.txtES != null && this.meta.txtES.toLowerCase().indexOf(descripcionCheck) > -1)
        || (this.meta.txtEN != null && this.meta.txtEN.toLowerCase().indexOf(descripcionCheck) > -1)
        || (this.meta.txtFR != null && this.meta.txtFR.toLowerCase().indexOf(descripcionCheck) > -1))) {
      isVisible = true;
    } else {
      if (descripcionCheck.length == 0) {
        isVisible = true;
      } else {
        isVisible = false;
      }
    }

    return isVisible;
  }

  checkColeccionFiltro(coleccionFiltro, nombreColeccionMeta) {
    let isVisible = this.meta.show,
      checker = [];

    if (coleccionFiltro.length > 0) {
      coleccionFiltro.map(id => {
        const temp = this.meta[nombreColeccionMeta].filter(el => el.id == id);
        if (temp.length == 1) {
          checker.push(temp[0]);
        }
      });
    }

    if (checker.length > 0 || coleccionFiltro.length == 0) {
      isVisible = isVisible || true;
    } else {
      isVisible = false;
    }
    return isVisible;
  }

  guardarEstadoConexion(estado) {
    const objeto = {
      id: this.meta.id,
      categoria: this.meta.categoria.ordenAgrupador,
      estado
    };
    this.conexionesService.guardarEstadoConexion(objeto);
  }

  mostrarConexiones(dir) {// dir => direccion
    this.conexionesService.showConexiones(dir, this.meta);
  }

  editar(id) {
    this.throbberService.setThrobberState(true);
    const sub = this.estudioService.getMeta(id, true).subscribe(res => {
      // this.throbberService.setThrobberState(false);
      this.onEdit.emit(res);
    }, err => {
    }, () => {
      this.throbberService.setThrobberState(false);
      sub.unsubscribe();
    });

    // this.mapaCurricularService.emitAbrirModal(id, 'meta');
  }

  setEstadoBulk(estado) {
    this.meta.bulkSelected = estado;
  }
}
